/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CounterWidgetDataEntry } from '../models/counter-widget-data-entry';
import { CounterWidgetDataEntryDto } from '../models/counter-widget-data-entry-dto';
import { CounterWidgetDataEntryEndUserDto } from '../models/counter-widget-data-entry-end-user-dto';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class CounterWidgetControllerService extends DataBaseService {

  /**
   * Path part for operation counterWidgetControllerGetCounterWidgetsEndUser
   */
  static readonly CounterWidgetControllerGetCounterWidgetsEndUserPath = '/v1/counter-widgets/end-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounterWidgetsEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsEndUser$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<CounterWidgetDataEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, CounterWidgetControllerService.CounterWidgetControllerGetCounterWidgetsEndUserPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CounterWidgetDataEntry>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounterWidgetsEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsEndUser(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<CounterWidgetDataEntry>> {

    return this.getCounterWidgetsEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CounterWidgetDataEntry>>) => r.body as Array<CounterWidgetDataEntry>)
    );
  }

  /**
   * Path part for operation counterWidgetControllerGetCounterWidgetsCountEndUser
   */
  static readonly CounterWidgetControllerGetCounterWidgetsCountEndUserPath = '/v1/counter-widgets/{id}/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounterWidgetsCountEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsCountEndUser$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, CounterWidgetControllerService.CounterWidgetControllerGetCounterWidgetsCountEndUserPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounterWidgetsCountEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsCountEndUser(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.getCounterWidgetsCountEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation counterWidgetControllerGetCounterWidgetsEntriesEndUser
   */
  static readonly CounterWidgetControllerGetCounterWidgetsEntriesEndUserPath = '/v1/counter-widgets/{id}/entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounterWidgetsEntriesEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsEntriesEndUser$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<CounterWidgetDataEntryEndUserDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CounterWidgetControllerService.CounterWidgetControllerGetCounterWidgetsEntriesEndUserPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CounterWidgetDataEntryEndUserDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounterWidgetsEntriesEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgetsEntriesEndUser(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<CounterWidgetDataEntryEndUserDto>> {

    return this.getCounterWidgetsEntriesEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CounterWidgetDataEntryEndUserDto>>) => r.body as Array<CounterWidgetDataEntryEndUserDto>)
    );
  }

  /**
   * Path part for operation counterWidgetControllerGetCounterWidgets
   */
  static readonly CounterWidgetControllerGetCounterWidgetsPath = '/v1/counter-widgets';

  /**
   * Get counter widgets DTO
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounterWidgets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgets$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<CounterWidgetDataEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CounterWidgetControllerService.CounterWidgetControllerGetCounterWidgetsPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CounterWidgetDataEntryDto>>;
      })
    );
  }
  /**
   * Get counter widgets DTO
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounterWidgets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounterWidgets(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<CounterWidgetDataEntryDto>> {

    return this.getCounterWidgets$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CounterWidgetDataEntryDto>>) => r.body as Array<CounterWidgetDataEntryDto>)
    );
  }

}
